<template>
    <ds-modal
        title="Filter"
        :is-open="open"
        show-close
        intercept-close
        size="lg"
        @close="close"
    >
        <section>
            <form
                ref="form"
                novalidate
                @submit.prevent="submit"
                @reset.prevent="reset"
            >
                <section>
                    <section v-for="(filter, i) in filters" :key="i">
                        <analytics-filter
                            v-model="filters[i]"
                            @remove="removeFilter(i)"
                        />
                    </section>

                    <ds-multiselect
                        v-show="filterOptions.length"
                        ref="selectedFilter"
                        v-model="selectedFilter"
                        searchable
                        pin-bottom
                        placeholder="Add a filter"
                        :options="filterOptions"
                        @input="selectFilter($event)"
                    />
                </section>

                <section class="actions">
                    <ds-filled-button type="submit">
                        View results
                    </ds-filled-button>

                    <ds-text-button type="reset">
                        Reset
                    </ds-text-button>
                </section>
            </form>
        </section>
    </ds-modal>
</template>

<script>
import clone from 'lodash.clonedeep';

import AnalyticsFilter from './AnalyticsFilter';

export default {
    components: {
        AnalyticsFilter,
    },

    props: {
        value: Array,
        options: Array,
        open: Boolean,
    },

    data() {
        return {
            filters: clone(this.value),
            selectedFilter: '',
            CORE_API_URL: `${window.location.protocol}//${window.location.host}`,
        };
    },

    watch: {
        value: {
            handler(value) {
                this.filters = clone(value);
            },
            deep: true,
        },
    },

    computed: {
        filterOptions() {
            const options = [];

            this.options.forEach((option) => {
                const existingOption = this.filters.find(({ key }) => key === option.key);

                if (!existingOption) {
                    options.push(option);
                }
            });

            return options;
        },
    },

    methods: {
        submit() {
            this.$emit('input', this.filters);
            this.close();
        },

        selectFilter(filter) {
            if (filter && filter.key) {
                const selectedFilter = clone(filter);

                this.filters.push(selectedFilter);

                if (this.$refs.selectedFilter) {
                    this.$refs.selectedFilter.selected = null;
                }
            }
        },

        removeFilter(i) {
            this.filters.splice(i, 1);
        },

        reset() {
            this.filters = [];

            if (this.$refs.selectedFilter) {
                this.$refs.selectedFilter.selected = null;
            }
        },

        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.actions {
    margin: 0 -1.5rem;
    padding: $spacing-300 $spacing-300 0;
    border-top: 1px solid $color-gray-lighter;

    button {
        &:first-child {
            @include margin-end($spacing-200);
        }
    }
}
</style>
